class CompatLatLon {
    constructor(lat, lon) {
        this.Latitude = lat;
        this.Longitude = lon;
    }

    lat() {
        return this.Latitude;
    }
    lng() {
        return this.Longitude;
    }
}

// Encode a signed number in the encode format.
function encodeSignedNumber(num) {
    var sgn_num = num << 1;

    if (num < 0) {
        sgn_num = ~(sgn_num);
    }

    return (encodeNumber(sgn_num));
}

// Encode an unsigned number in the encode format.
function encodeNumber(num) {
    var encodeString = "";

    while (num >= 0x20) {
        encodeString += (String.fromCharCode((0x20 | (num & 0x1f)) + 63));
        num >>= 5;
    }

    encodeString += (String.fromCharCode(num + 63));
    return encodeString;
}

// Create the encoded bounds.
function createEncodings(points) {
    var i = 0;
    var plat = 0;
    var plng = 0;
    var encoded_points = "";

    for (i = 0; i < points.length; ++i) {
        var point = points[i];
        var lat = point.Latitude;
        var lng = point.Longitude;

        var late5 = Math.floor(lat * 1e5);
        var lnge5 = Math.floor(lng * 1e5);

        dlat = late5 - plat;
        dlng = lnge5 - plng;

        plat = late5;
        plng = lnge5;

        encoded_points += encodeSignedNumber(dlat) + encodeSignedNumber(dlng);
    }
    return encoded_points;
}

/** Stack-based Douglas Peucker line simplification routine
 *  returned is a reduced GLatLng array
 *  After code by  Dr. Gary J. Robinson,
 *  Environmental Systems Science Centre,
 *  University of Reading, Reading, UK
 * adapted from http://www.bdcc.co.uk/Gmaps/GDouglasPeuker.js
 */
eContentAlgorithmsDouglasPeucker = function(source, kink) {
    /* source[] Input coordinates in GLatLngs 	*/
    /* kink	in metres, kinks above this depth kept  */
    /* kink depth is the height of the triangle abc where a-b and b-c are two consecutive line segments */

    var n_source, n_stack, n_dest, start, end, i, sig;
    var dev_sqr, max_dev_sqr, band_sqr;
    var x12, y12, d12, x13, y13, d13, x23, y23, d23;
    var F = ((Math.PI / 180.0) * 0.5);
    var index = []; /* aray of indexes of source points to include in the reduced line */
    var sig_start = []; /* indices of start & end of working section */
    var sig_end = [];

    /* check for simple cases */

    if (source.length < 3)
        return (source); /* one or two points */

    /* more complex case. initialize stack */

    n_source = source.length;
    band_sqr = kink * 360.0 / (2.0 * Math.PI * 6378137.0); /* Now in degrees */
    band_sqr *= band_sqr;
    n_dest = 0;
    sig_start[0] = 0;
    sig_end[0] = n_source - 1;
    n_stack = 1;

    /* while the stack is not empty  ... */
    while (n_stack > 0) {
        /* ... pop the top-most entries off the stacks */

        start = sig_start[n_stack - 1];
        end = sig_end[n_stack - 1];
        n_stack--;

        if ((end - start) > 1) {
            /* any intermediate points ? */

            /* ... yes, so find most deviant intermediate point to
                    either side of line joining start & end points */

            x12 = (source[end].lng() - source[start].lng());
            y12 = (source[end].lat() - source[start].lat());
            if (Math.abs(x12) > 180.0)
                x12 = 360.0 - Math.abs(x12);
            x12 *= Math.cos(F * (source[end].lat() + source[start].lat())); /* use avg lat to reduce lng */
            d12 = (x12 * x12) + (y12 * y12);

            for (i = start + 1, sig = start, max_dev_sqr = -1.0; i < end; i++) {

                x13 = (source[i].lng() - source[start].lng());
                y13 = (source[i].lat() - source[start].lat());
                if (Math.abs(x13) > 180.0)
                    x13 = 360.0 - Math.abs(x13);
                x13 *= Math.cos(F * (source[i].lat() + source[start].lat()));
                d13 = (x13 * x13) + (y13 * y13);

                x23 = (source[i].lng() - source[end].lng());
                y23 = (source[i].lat() - source[end].lat());
                if (Math.abs(x23) > 180.0)
                    x23 = 360.0 - Math.abs(x23);
                x23 *= Math.cos(F * (source[i].lat() + source[end].lat()));
                d23 = (x23 * x23) + (y23 * y23);

                if (d13 >= (d12 + d23))
                    dev_sqr = d23;
                else if (d23 >= (d12 + d13))
                    dev_sqr = d13;
                else
                    dev_sqr = (x13 * y12 - y13 * x12) * (x13 * y12 - y13 * x12) / d12; // solve triangle

                if (dev_sqr > max_dev_sqr) {
                    sig = i;
                    max_dev_sqr = dev_sqr;
                }
            }

            if (max_dev_sqr < band_sqr) {
                /* is there a sig. intermediate point ? */
                /* ... no, so transfer current start point */
                index[n_dest] = start;
                n_dest++;
            } else {
                /* ... yes, so push two sub-sections on stack for further processing */
                n_stack++;
                sig_start[n_stack - 1] = sig;
                sig_end[n_stack - 1] = end;
                n_stack++;
                sig_start[n_stack - 1] = start;
                sig_end[n_stack - 1] = sig;
            }
        } else {
            /* ... no intermediate points, so transfer current start point */
            index[n_dest] = start;
            n_dest++;
        }
    }

    /* transfer last point */
    index[n_dest] = n_source - 1;
    n_dest++;

    /* make return array */
    var r = [];
    for (var ii = 0; ii < n_dest; ii++)
        r.push(source[index[ii]]);
    return r;
};

eContentAlgorithmsDouglasPeuckerWithMaxCount = function(points, max) {
    var kink = 10;
    while (points.length > max) {
        points = eContentAlgorithmsDouglasPeucker(points, kink);
        kink *= 2;
    }
    return points;
};


// ------------

class eContentElevationChart {
    constructor(ecMap, options) {
        if (!window.jQuery) throw new Error('eContent.ElevationChart needs jQuery!');
        if (!window.d3) throw new Error('eContent.ElevationChart needs d3!');

        this._ecMap = ecMap;
        this._options = options || {};
        this._options.fullScreenChart = options.fullScreenChart || false;
        this._options.hinweistext = this._options.hinweistext || 'Maus über das Höhenprofil für Details';
        this._options.routeDetails = this._options.routeDetails || false;

        this.prepareChart();
        this.addListener();
    }

    prepareChart() {
        var self = this;

        this.margin = this._options.margin || {
            top: 20,
            right: 16,
            // bottom: (this._options.fullScreenChart) ? 50 : 30,
            bottom: (this._options.routeDetails) ? 60 : 50,
            left: 50
        };

        var h = ($('#' + this._options.element).height()) ? $('#' + this._options.element).height() : 150,
            w = ($('#' + this._options.element).width()) ? $('#' + this._options.element).width() : 650;

        this.width = w - this.margin.left - this.margin.right;
        this.height = h - this.margin.top - this.margin.bottom;

        this.x = d3.scale.linear()
            .range([0, this.width]);

        this.y = d3.scale.linear()
            .range([this.height, 0]);

        this.xAxis = d3.svg.axis()
            .scale(this.x)
            .orient("bottom")
            .tickFormat(this._formatKilometer);

        this.yAxis = d3.svg.axis()
            .scale(this.y)
            .orient("left")
            .tickFormat(this._formatMeter);

        this.area = d3.svg.area()
            .x(function(d) {
                return self.x(d.distance);
            })
            .y0(this.height)
            .y1(function(d) {
                return self.y(d.elevation);
            })
            //.defined(function(d) { return !isNaN(d.elevation); })
            //.interpolate('linear')
            ;

        this.svg = d3.select('#' + this._options.element).append('svg')
            .attr("width", this.width + this.margin.left + this.margin.right)
            .attr("height", this.height + this.margin.top + this.margin.bottom)
            .attr('class', (this.width < 500) ? 'XAxisLegendFix' : '')
            .append("g")
            .attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");

        if (this._options.routeDetails) {
            this.svg.append("g").attr("transform", "translate(0,102)").attr('class', 'routeDetails').append("text").text(self._options.routeDetails);
        }
        this.svg.append("g").attr("transform", "translate(0,115)").attr('class', 'hinweis').append("text").text(self._options.hinweistext);

        this.svg.append("path")
            .attr("class", "area");
        //        .attr("fill", "url(#areaGradient)");

        this.svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0," + this.height + ")");

        this.svg.append("g")
            .attr("class", "y axis");

        this.svg.append("g")
            .attr("class", "pois");

        var container = this.svg.append("g")
            .attr('class', 'marker-container')
            .attr("display", "none");
        container.append("line")
            .attr("class", "marker")
            .attr("x1", 0)
            .attr("y1", 0)
            .attr("x2", 0)
            .attr("y2", this.height);
        container.append("circle")
            .attr("class", "marker-circle")
            .attr("r", 3)
            .attr("cx", 0)
            .attr("cy", 0);
        container.append("rect")
            .attr("class", "marker-text-bg")
            .attr("height", 13)
            .attr("width", 55)
            .attr("x", 0)
            .attr("y", 0);
        container.append("text")
            .attr("class", "marker-text height")
            .attr("x", 5)
            .attr("dy", 10)
            .attr("text-anchor", "left");
        container.append("rect")
            .attr("class", "marker-text-bg")
            .attr("height", 13)
            .attr("width", 55)
            .attr("x", 0)
            .attr("y", this.height - 13);
        container.append("text")
            .attr("class", "marker-text distance")
            .attr("x", 5)
            .attr("y", this.height - 13)
            .attr("dy", 10)
            .attr("text-anchor", "left");
        /*container.append("rect")
            .attr("class", "marker-text-bg")
            .attr("height", 13)
            .attr("width", 55)
            .attr("x", 0)
            .attr("y", this.height - 27);*/
        container.append("text")
            .attr("class", "marker-text time")
            .attr("x", 5)
            .attr("y", this.height - 27)
            .attr("dy", 10)
            .attr("text-anchor", "left");

        this.svg.append("rect")
            .attr("class", "event")
            .attr("x", 0)
            .attr("y", 0)
            .attr("width", this.width)
            .attr("height", this.height);

        //Should be above event rect
        this.camAreaContainer = this.svg.append("g")
            .attr("class", "cam-areas");

    }

    addListener() {
        var self = this;
        var marker = d3.select('#' + this._options.element + ' .marker-container'),
            markerCircle = marker.select('.marker-circle'),
            markerText = marker.selectAll(".marker-text"),
            markerTextDistance = marker.select(".marker-text.distance"),
            markerTextHeight = marker.select(".marker-text.height"),
            markerTextTime = marker.select(".marker-text.time"),
            markerTextBg = marker.selectAll(".marker-text-bg");

        var path = d3.select('#' + this._options.element + ' rect.event')
            .on('mousemove', function() {
                var coords = d3.mouse(this),
                    fullWidth = this.getBoundingClientRect().width;

                var percentage = coords[0] / fullWidth;

                var points = self._chartData;
                if (points) {
                    var fullDistance = points[points.length - 1].distance;
                    var currentDistance = 0;
                    var i = 0;
                    while ((currentDistance / fullDistance) < percentage) {
                        i++;
                        currentDistance = points[i].distance;
                    }

                    markerTextDistance.text(self._formatKilometer(currentDistance));
                    markerTextHeight.text(self._formatMeter(points[i].elevation));
                    markerCircle.attr('cy', self.y(points[i].elevation));
                    //markerTextTime.text(text);

                    if (true /*show on map*/) {

                        if (_ttgMaps.elevationPin) {
                            _ttgMaps.elevationPin.remove();
                        }

                        // _ttgMaps.elevationPin = self._ecMap.addMarker({
                        //     lng: points[i].Longitude,
                        //     lat: points[i].Latitude,
                        //     color: _ttgMaps.pinColors.selected
                        // });
                        _ttgMaps.elevationPin = self._ecMap.addLocationMarker({
                            lng: points[i].Longitude,
                            lat: points[i].Latitude,
                            color: '#CC3333'
                        });

                        var standortVal = '<span class="val">' + self._formatKilometer(currentDistance).split(' ')[0] + '</span>',
                            standortEinheit = '<span class="einheit">' + self._formatKilometer(currentDistance).split(' ')[1] + '</span>';

                        if ($(_ttgMaps.elevationPin._element).find('span').length === 0) {
                            $(_ttgMaps.elevationPin._element)
                                .addClass('ttgMaps_elevationPin')
                                .addClass('ttgMaps_locationPin') /* NEW ONE */
                                .append(
                                    $('<span />')
                                        .addClass('ttgMaps_pinText')
                                        .html(standortVal + standortEinheit)
                                );
                        } else {
                            $(_ttgMaps.elevationPin._element).find('span')
                                .html(standortVal + standortEinheit);
                        }
                    }

                    if (self._options.onmouseover) {
                        self._options.onmouseover({
                            percentage: percentage,
                            point: point
                        });
                    }

                }

                marker
                    .attr("display", "")
                    .attr("transform", "translate(" + (coords[0] - 1) + ", 0)");
                if (fullWidth - coords[0] < 60) {
                    markerTextBg.attr("transform", "translate(-55, 0)");
                    markerText.attr("transform", "translate(-55, 0)");
                } else {
                    markerTextBg.attr("transform", "");
                    markerText.attr("transform", "");
                }
            }).on('mouseout', function() {
                marker.attr("display", "none");
                _ttgMaps.elevationPin.remove();
                if (self._options.onmouseout) self._options.onmouseout.call(self);
            });
    }

    drawChart(points) {
        var self = this;
        var data = points;

        this._chartData = points;

        var xDomain = d3.extent(data, function(d) {
            return d.distance;
        });
        this.x.domain(xDomain);

        var yDomain = [d3.min(data, function(d) {
            return d.elevation;
        }),
        d3.max(data, function(d) {
            return d.elevation;
        })
        ];

        this.y.domain(yDomain);

        this.svg.select('path.area')
            .datum(data)
            .attr("d", this.area);

        this.svg.select(".y.axis")
            .call(this.yAxis);

        this.svg.select(".x.axis")
            .call(this.xAxis);

    }

    setLineString(linestring) {

    }

    setPoints(points) {
        var self = this;
        //TODO resetChart() ?

        this._enrichRunningDistance(points);

        var reducedPoints = this._reducePointsWithMaxCount(points, this._options.samples || 250);

        this._getElevationData(reducedPoints, function(elevdata) {
            if (elevdata.results.length != reducedPoints.length) throw new Error("elevdata length != points length");
            for (var i = 0; i < reducedPoints.length; i++) {
                reducedPoints[i].elevation = elevdata.results[i].elevation;
            }

            // console.log("narf", reducedPoints);

            //NOTE: original points are also automatically enriched because Douglas doesnt copy the points
            //but this is a side effect that may not last forever

            //self._setEnrichedPoints(points);
            self._setEnrichedPoints(reducedPoints);

        });
    }

    /**
     * points: some of the points have a .elevation, segments are generated for each group
     */
    _setEnrichedPoints(points) {
        //TODO resetChart() ?
        this.drawChart(points);
    }

    _enrichRunningDistance(points) {
        var d = 0;
        for (var i = 0; i < points.length; i++) {
            var p = points[i];
            if (i > 0) {
                var prev = points[i - 1];
                d += this._calculateDistance(prev, p);
            }
            p.distance = d;
        }
    }

    _reducePointsWithMaxCount(points, max) {
        var kink = 10;
        while (points.length > max) {
            points = eContentAlgorithmsDouglasPeucker(points, kink);
            kink *= 2;
        }
        return points;
    }

    _getElevationData(points, success, error) {
        //http://elevation.ecmaps.de/maps/api/elevation/json?locations=39.7391536,-104.9847034|36.455556,-116.866667&sensor=true&callback=bar
        // console.log("narf _getElevationData", points);

        $.ajax({
            dataType: "json",
            url: 'https://elevation.ecmaps.de/maps/api/elevation/json',
            data: {
                locations: 'enc:' + createEncodings(points),
                sensor: true
            },
            success: function(data) {
                if (data.status == 'OK') success(data);
                if (error) error(data);
            },
            error: function(hmm) {
                if (error) error(hmm);
            }
        });
    }

    _calculateDistance(p1, p2) {
        var rad = function(x) {
            return x * Math.PI / 180;
        };

        var R = 6378137; // Earth’s mean radius in meter
        var dLat = rad(p2.Latitude - p1.Latitude);
        var dLong = rad(p2.Longitude - p1.Longitude);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(rad(p1.Latitude)) * Math.cos(rad(p2.Latitude)) *
            Math.sin(dLong / 2) * Math.sin(dLong / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return d; // returns the distance in meter
    }

    _formatKilometer(d) {
        if (d < 1000) {
            return Math.round(d) + " m";
        } else {
            return (parseFloat(d / 1000).toFixed(2) + "").replace(/\./, ',') + " km";
        }
    }

    _formatMeter(d) {
        return Math.round(d) + " m";
    }
}